import { html } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';

import {
  correctnessIndicatorStyles,
  defaultCellFontSize,
  responseStyles,
} from '../cssUtils.js';
import { getIcon, processEscapedMarkup } from '../utils.js';
import { CustomLitElement } from '../CustomLitElement.js';

/**
 * @element constructed-response
 * @prop {Object} model - The model for the pie
 * @prop {Object} session - The response session
 * @cssprop --pie-live-session-background-color - change the background color
 * @cssprop --pie-live-session-text-color - change the text color
 * @cssprop --pie-live-session-font-family - change the font family
 * @cssprop --pie-live-session-font-size-small - change the font size
 * @cssprop --pie-live-session-response-height - change the height (must be valid, eg: 100px, 10em )
 * @cssprop --pie-live-session-response-width - change the width (must be valid, eg: 100px, 10em )
 */
export class ConstructedResponse extends CustomLitElement {
  static get properties() {
    return {
      model: { type: Object, attribute: false },
      session: { type: Array, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  _renderResponse() {
    const { choices, markup } = this.model || {};
    const { value } = this.session || {};

    if (!value || !markup) return '';

    const text = processEscapedMarkup(markup);
    const matches = text ? text.match(/\{\{(.)\}\}/g) : [];

    return `
    <div>
    ${matches.join(' ... ').replace(/\{\{(.)\}\}/g, (match, group) => {
      const isCorrect =
        choices[group] && choices[group].find(ch => ch.label === value[group]);

      return `
        <span class="answer">
        ${value[group] || ''}
        <span class="correctness-indicator">${getIcon(isCorrect, true)}</span>
        </span>`;
    })}
    </div>`;
  }

  render() {
    return html` <style>
        ${correctnessIndicatorStyles} ${responseStyles} .response.constructed {
          font-size: var(
            --pie-live-session-font-size-small,
            ${defaultCellFontSize}px
          );
          overflow: auto;
        }

        .constructed p {
          line-height: 2;
          margin: 0;
        }

        .constructed .answer {
          border: 1px dotted;
          padding: 0 2px;
          line-height: 1.5;
        }
      </style>
      <div class="response constructed">
        ${unsafeHTML(this._renderResponse())}
      </div>`;
  }
}

export default ConstructedResponse;
